export default {
	LOGIN(state, payload) {
		state.kSession = payload.sid;
		state.user_data = payload.user;
	},
	UPDATE_USER_DATA(state, payload) {
		state.user_data = payload;
	},
	LOGOUT(state) {
		state.kSession = '';
		state.user_data = null;
	},
};



// WEBPACK FOOTER //
// ./src/vuex/mutations.js